export default (props, vars) =>
  `https://www.youtube.com/embed/${props?.['id']}`;
